import { render, staticRenderFns } from "./main-navbar.vue?vue&type=template&id=3a834b47&scoped=true&"
import script from "./main-navbar.vue?vue&type=script&lang=js&"
export * from "./main-navbar.vue?vue&type=script&lang=js&"
import style0 from "./main-navbar.vue?vue&type=style&index=0&id=3a834b47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a834b47",
  null
  
)

export default component.exports